import { connect } from "react-redux";

import { LastInstanceBehaviour, removeInstance } from "../../../Engine/ActionCreators/AllActionCreators";
import { withResolvePaths } from "../../withResolvePaths";
import { CandyDispatch } from "../../../Engine/Core/Store/CandyReduxTypes";
import { AbsoluteResolvedModelPath, SimplePathToken } from "../../../../../Common/ModelPath/ModelPath";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";

import { RemoveRowButton } from "./RemoveRowButton";

interface RemoveRowButtonContainerProps {
    clearLastInstance?: boolean;
    optional?: boolean;
    filteredUniqKey?: string;
}

const mapDispatchToProps = (dispatch: CandyDispatch, ownProps: RemoveRowButtonContainerProps) => ({
    onRemoveInstance: (bindingPath: AbsoluteResolvedModelPath, instancesToRemove: SimplePathToken) => {
        dispatch(
            removeInstance(
                bindingPath,
                instancesToRemove,
                ownProps.clearLastInstance || ownProps.optional === false
                    ? LastInstanceBehaviour.Clear
                    : LastInstanceBehaviour.Remove,
                ownProps.filteredUniqKey
            )
        );
    },
});

const mapStateToProps = (state: FullFormState) => ({
    isReadOnly: state.settings.isReadOnly,
});

export const RemoveRowButtonContainer = withResolvePaths(connect(mapStateToProps, mapDispatchToProps)(RemoveRowButton));
